import { useTranslation } from "react-i18next";

/** Renders a translated string and re-renders when the language changes. */
export function T({ k, values }: { k: string; values?: Record<string, unknown> }) {
  const { t } = useTranslation();
  return <>{t(k, values)}</>;
}
